import * as React from 'react';
import PDHeader from './components/PDHeader';
import PDMap from './components/PDMap';
import PDChildren from './components/PDChildren';
import children from './data/children';
import PDChildSupporters from './components/PDChildSupporters';
import PDFooter from './components/PDFooter';
import clubs from './data/clubs';
import { useLocation } from 'react-router';
import './partnersDashboard.css';

function PartnersDashboard(): React.ReactElement {
  const [currentChild, setCurrentChild] = React.useState<any>();
  const currentClubs = React.useMemo(() => clubs.filter(c => currentChild && c.country === currentChild.country), [currentChild]);
  const location = useLocation<{ isEmbedded }>();
  const isEmbedded = location.search;
  function handleTransion(child): void {
    setCurrentChild(child);
  }
  return (
    <div className={`partners-dashboard ${isEmbedded ? 'partners-dashboard--iframe' : ''}`}>
      {!isEmbedded && <PDHeader />}
      {currentChild && <PDMap child={currentChild} />}
      <PDChildren children={children} onTransition={handleTransion} />
      {currentChild && <PDChildSupporters clubs={currentClubs} agency={currentChild.agencyName} agencyLogo={currentChild.agencyLogo} />}
      {isEmbedded && <PDFooter />}
    </div>
  )
}

export default React.memo(PartnersDashboard);
